module.exports = __webpack_public_path__ + "img/full6-min.0e717350.png";